import { useTranslation } from 'react-i18next';

import { Icon404 } from 'icons';
import { Namespace } from 'enums';

import styles from './AccessDeniedPage.module.scss';

export const AccessDeniedPage = () => {
  const { t } = useTranslation(Namespace.AccessDenied);

  return (
    <div className={styles.accessDenied}>
      <Icon404 />
      <h2 className={styles.accessDeniedTitle}>{t('accessDenied')}</h2>
    </div>
  );
};
